export default __webpack_public_path__ + "static/media/Mail.32f750ab.svg";